import $i18n from '@/i18n';

// 获取空间状态
export const getSpaceStatus = (key) => {
  const status = {
    CREATED: {
      tagTheme: 'blue',
      name: $i18n.get({
        id: 'aopf.pages.getSpaceStatus.created',
        dm: '创建',
      }),
    },
    BLOCKED: {
      tagTheme: 'grey',
      name: $i18n.get({
        id: 'aopf.pages.getSpaceStatus.freeze',
        dm: '冻结',
      }),
    },
    PENDING: {
      tagTheme: 'orange',
      name: $i18n.get({
        id: 'aopf.pages.getSpaceStatus.underReview',
        dm: '审核中',
      }),
    },
    WITHDRAW: {
      tagTheme: 'grey',
      name: $i18n.get({
        id: 'aopf.pages.getSpaceStatus.withdrawn',
        dm: '已撤回',
      }),
    },
    ACTIVE: {
      tagTheme: 'green',
      name: $i18n.get({
        id: 'aopf.pages.getSpaceStatus.active',
        dm: '激活',
      }),
    },
    REJECT: {
      tagTheme: 'red',
      name: $i18n.get({
        id: 'aopf.pages.getSpaceStatus.rejected',
        dm: '已拒绝',
      }),
    },
  };
  return status[key];
};

// 获取审批状态
export const getApprovalsResult = (key) => {
  const status = {
    PASSED: {
      tagTheme: 'green',
      name: $i18n.get({
        id: 'aopf.pages.getApprovalsResult.approved',
        dm: '已批准',
      }),
    },
    REJECT: {
      tagTheme: 'red',
      name: $i18n.get({
        id: 'aopf.pages.getApprovalsResult.rejected',
        dm: '已拒绝',
      }),
    },
    WITHDRAW: {
      tagTheme: 'grey',
      name: $i18n.get({
        id: 'aopf.pages.getApprovalsResult.withdrawn',
        dm: '已撤回',
      }),
    },
    APPROVE: {
      tagTheme: 'orange',
      name: $i18n.get({
        id: 'aopf.pages.getApprovalsResult.pendingReview',
        dm: '审核中',
      }),
    },
    PROCESSING: {
      tagTheme: 'orange',
      name: $i18n.get({
        id: 'aopf.pages.getApprovalsResult.pendingReview',
        dm: '审核中',
      }),
    },
    // FINISHED: {
    //   tagTheme: 'green',
    //   name: 'FINISHED',
    // },
  };
  return status[key];
};

// // 获取应用状态
// export const getAppStatus = (key) => {
//   const status = {
//     CREATED: {
//       tagTheme: 'purple',
//       name: 'CREATED',
//     },
//     APPROVE: {
//       tagTheme: 'orange',
//       name: 'APPROVE',
//     },
//     REJECT: {
//       tagTheme: 'red',
//       name: 'REJECT',
//     },
//     PASSED: {
//       tagTheme: 'blue',
//       name: 'PASSED',
//     },
//     WITHDRAW: {
//       tagTheme: 'grey',
//       name: 'WITHDRAW',
//     },
//     GRAY: {
//       tagTheme: 'grey',
//       name: 'GRAY',
//     },
//     GRAY_SUSPEND: {
//       tagTheme: 'grey',
//       name: 'GRAY_SUSPEND',
//     },
//     ONLINE: {
//       tagTheme: 'green',
//       name: 'ONLINE',
//     },
//     OFFLINE: {
//       tagTheme: 'grey',
//       name: 'OFFLINE',
//     },
//   };
//   return status[key];
// };

// 获取应用版本状态
export const getAppVersionStatus = (key) => {
  const status = {
    CREATED: {
      tagTheme: 'purple',
      name: $i18n.get({
        id: 'aopf.pages.getAppVersionStatus.versionCreated',
        dm: '版本已创建',
      }),
    },
    APPROVE: {
      tagTheme: 'orange',
      // name: 'Pending Review',
      name: $i18n.get({
        id: 'aopf.pages.getAppVersionStatus.pendingReview',
        dm: '审核中',
      }),
    },
    REJECT: {
      tagTheme: 'red',
      // name: 'Rejected',
      name: $i18n.get({
        id: 'aopf.pages.getAppVersionStatus.rejected',
        dm: '已拒绝',
      }),
    },
    PASSED: {
      tagTheme: 'blue',
      // name: 'Approved',
      name: $i18n.get({
        id: 'aopf.pages.getAppVersionStatus.approved',
        dm: '已批准',
      }),
    },
    WITHDRAW: {
      tagTheme: 'grey',
      // name: 'Withdrawn',
      name: $i18n.get({
        id: 'aopf.pages.getAppVersionStatus.withdrawn',
        dm: '已撤回',
      }),
    },
    BETA_TEST: {
      tagTheme: 'blue',
      // name: 'Pilot Test',
      name: $i18n.get({
        id: 'aopf.pages.getAppVersionStatus.pilotTest',
        dm: '初步测试',
      }),
    },
    BETA_TEST_SUSPEND: {
      tagTheme: 'blue',
      // name: 'Pilot Test Termination',
      name: $i18n.get({
        id: 'aopf.pages.getAppVersionStatus.pilotTestTermination',
        dm: '初步测试终止',
      }),
    },
    GRAY: {
      tagTheme: 'grey',
      // name: 'Grayscale Release',
      name: $i18n.get({
        id: 'aopf.pages.getAppVersionStatus.grayscaleRelease',
        dm: '灰度发布',
      }),
    },
    GRAY_SUSPEND: {
      tagTheme: 'grey',
      // name: 'Grayscale Termination',
      name: $i18n.get({
        id: 'aopf.pages.getAppVersionStatus.grayscaleTermination',
        dm: '灰度终止',
      }),
    },
    ONLINE: {
      tagTheme: 'green',
      // name: 'Officially Release',
      name: $i18n.get({
        id: 'aopf.pages.getAppVersionStatus.officiallyRelease',
        dm: '正式发布',
      }),
    },
    OFFLINE: {
      tagTheme: 'grey',
      // name: 'Archived',
      name: $i18n.get({
        id: 'aopf.pages.getAppVersionStatus.archived',
        dm: '归档',
      }),
    },
  };
  return status[key];
};

// 成员状态
export const getMemberStatus = (key) => {
  const status = {
    ACTIVATE: {
      tagTheme: 'green',
      // name: 'Active',
      name: $i18n.get({
        id: 'aopf.pages.getMemberStatus.active',
        dm: '激活',
      }),
    },
    BLOCKED: {
      tagTheme: 'red',
      // name: 'Disabled',
      name: $i18n.get({
        id: 'aopf.pages.getMemberStatus.disabled',
        dm: '已禁止',
      }),
    },
  };
  return status[key];
};

// 邀请状态
export const getInvitateStatus = (key) => {
  const status = {
    INVITE: {
      tagTheme: 'orange',
      // name: 'Invitation Sent',
      name: $i18n.get({
        id: 'aopf.pages.getInvitateStatus.invitationSent',
        dm: '已发送邀请',
      }),
    },
    EXPIRE: {
      tagTheme: 'red',
      // name: 'Invitation Expired',
      name: $i18n.get({
        id: 'aopf.pages.getInvitateStatus.invitationExpired',
        dm: '邀请已过期',
      }),
    },
    WITHDRAW: {
      tagTheme: 'grey',
      // name: 'Withdrawn',
      name: $i18n.get({
        id: 'aopf.pages.getInvitateStatus.withdrawn',
        dm: '已撤回',
      }),
    },
    USE: {
      tagTheme: 'green',
      // name: 'Invitation Success',
      name: $i18n.get({
        id: 'aopf.pages.getInvitateStatus.invitationSuccess',
        dm: '邀请成功',
      }),
    },
  };
  return status[key];
};

// 渠道应用状态
export const getMiniAppStatus = (key) => {
  const status = {
    ONLINE: {
      tagTheme: 'green',
      // name: 'Released',
      name: $i18n.get({
        id: 'aopf.pages.getMiniAppStatus.released',
        dm: '已发布',
      }),
    },
    OFFLINE: {
      tagTheme: 'grey',
      // name: 'Released',
      name: $i18n.get({
        id: 'aopf.pages.getMiniAppStatus.offline',
        dm: '已下线',
      }),
    },
    BLOCKED: {
      tagTheme: 'red',
      // name: 'Disabled',
      name: $i18n.get({
        id: 'aopf.pages.getMiniAppStatus.disabled',
        dm: '已禁止',
      }),
    },
  };
  return status[key];
};
